import { computed, unref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function resolveRouteTab(tabs, requested) {
  const ids = tabs.map(tab => tab.id)
  return ids.includes(requested) ? requested : ids[0]
}

export function useRouteTabs(tabs, basePath, { keepHash = false } = {}) {
  const route = useRoute()
  const router = useRouter()

  const activeTab = computed(() => resolveRouteTab(unref(tabs), route.params.tab))

  const sections = computed(() =>
    unref(tabs).map(tab => ({
      id: tab.id,
      name: tab.name,
      active: tab.id === activeTab.value,
      action: () => router.push({ path: `${unref(basePath)}/${tab.id}`, hash: keepHash ? route.hash : '' })
    }))
  )

  return { activeTab, sections }
}
